// Diccionarios de traducción
// Para añadir un idioma nuevo: copiar uno existente y traducir los valores

export const dictionaries = {
  es: {
    // Login
    'login.title': 'Compras Semanales',
    'login.email': 'Correo electrónico',
    'login.password': 'Contraseña',
    'login.submit': 'Iniciar sesión',
    'login.loading': 'Ingresando...',
    'login.invalidCredentials': 'Credenciales inválidas',
    'login.helpText': 'Empleado: empleado@metro.com / Empleado123!  •  Admin: admin@metro.com / Admin123!',
    'login.fillFields': 'Completá email y contraseña',
    'login.welcome': 'Bienvenido',

    // User account
    'account.menu': 'Mi cuenta',
    'account.changePassword': 'Cambiar contraseña',
    'account.currentPassword': 'Contraseña actual',
    'account.newPassword': 'Nueva contraseña',
    'account.confirmPassword': 'Confirmar nueva contraseña',
    'account.passwordsDontMatch': 'Las contraseñas no coinciden',
    'account.passwordMin': 'La contraseña debe tener al menos 8 caracteres',
    'account.passwordChanged': 'Contraseña cambiada correctamente',

    // Users management (admin)
    'users.title': 'Usuarios',
    'users.newUser': '+ Nuevo usuario',
    'users.email': 'Correo electrónico',
    'users.role': 'Rol',
    'users.password': 'Contraseña',
    'users.status': 'Estado',
    'users.lastLogin': 'Último acceso',
    'users.actions': 'Acciones',
    'users.roleEmployee': 'Empleado',
    'users.roleAdmin': 'Administrador',
    'users.statusActive': '✓ Activo',
    'users.statusInactive': '✗ Inactivo',
    'users.never': 'Nunca',
    'users.activate': 'Activar',
    'users.deactivate': 'Desactivar',
    'users.resetPassword': 'Resetear contraseña',
    'users.formTitleNew': 'Nuevo usuario',
    'users.formTitleEdit': 'Editar usuario',
    'users.created': 'Usuario creado',
    'users.updated': 'Usuario actualizado',
    'users.passwordReset': 'Contraseña reseteada',
    'users.activated': 'Usuario activado',
    'users.deactivated': 'Usuario desactivado',
    'users.deactivateConfirm': '¿Desactivar al usuario "{email}"? Sus sesiones se cerrarán inmediatamente.',
    'users.activateConfirm': '¿Activar al usuario "{email}"?',
    'users.resetPasswordPrompt': 'Nueva contraseña para "{email}" (mínimo 8 caracteres):',

    // Header
    'header.logout': 'Salir',
    'header.catalog': 'Catálogo',
    'header.adminTitle': 'Compras Semanales (Admin)',

    // Common
    'common.loading': 'Cargando...',
    'common.cancel': 'Cancelar',
    'common.confirm': 'Confirmar',
    'common.accept': 'Aceptar',
    'common.save': 'Guardar',
    'common.delete': 'Eliminar',
    'common.edit': 'Editar',
    'common.back': '← Volver',
    'common.error': 'Error',
    'common.networkError': 'Error de red',
    'common.unknownError': 'Error desconocido',
    'common.requiredField': 'Este campo es obligatorio',
    'common.minChars': 'Mínimo {n} caracteres',
    'common.sessionExpired': 'Sesión expirada, volvé a ingresar',

    // Order statuses
    'status.DRAFT': 'Borrador',
    'status.SUBMITTED': 'Enviado a revisión',
    'status.UNDER_REVIEW': 'En revisión',
    'status.READY_TO_SEND': 'Listo para enviar',
    'status.SENT': 'Enviado a Metro',
    'status.CANCELLED': 'Cancelado',

    // Employee dashboard
    'orders.myOrders': 'Mis Pedidos',
    'orders.newOrder': '+ Nuevo pedido',
    'orders.empty': 'No tenés pedidos aún. Tocá "+ Nuevo pedido" para empezar.',
    'orders.orderCreated': 'Pedido creado',
    'orders.weekOf': 'Semana {week} de {year}',
    'orders.itemCount': '{n} productos',

    // Order editor
    'orderEditor.title': 'Pedido',
    'orderEditor.addProduct': 'Agregar producto',
    'orderEditor.product': 'Producto',
    'orderEditor.chooseProduct': '-- Elegí un producto --',
    'orderEditor.quantity': 'Cantidad',
    'orderEditor.unit': 'Unidad',
    'orderEditor.observations': 'Observaciones',
    'orderEditor.observationsOptional': 'Observaciones (opcional)',
    'orderEditor.addToOrder': 'Agregar al pedido',
    'orderEditor.added': 'Agregado',
    'orderEditor.remove': 'Quitar',
    'orderEditor.removeConfirm': '¿Quitar este producto del pedido?',
    'orderEditor.removed': 'Quitado',
    'orderEditor.products': 'Productos ({n})',
    'orderEditor.empty': 'Aún no agregaste productos.',
    'orderEditor.submit': 'Enviar a revisión',
    'orderEditor.submitConfirm': '¿Enviar este pedido al administrador?',
    'orderEditor.submitted': 'Pedido enviado a revisión',
    'orderEditor.print': 'Imprimir / PDF',
    'orderEditor.invalidProduct': 'Elegí un producto y una cantidad válida',
    'orderEditor.sku': 'SKU',
    'orderEditor.subtotal': 'Subtotal',
    'orderEditor.totalEstimated': 'Total estimado',
    'orderEditor.totalNote': 'Importe orientativo basado en precios de la última factura',

    // Admin
    'admin.tabs.pending': 'Pendientes',
    'admin.tabs.review': 'En revisión',
    'admin.tabs.ready': 'Listos para enviar',
    'admin.tabs.sent': 'Enviados',
    'admin.tabs.all': 'Todos',
    'admin.empty': 'No hay pedidos en este estado.',
    'admin.takeForReview': 'Tomar para revisar',
    'admin.taken': 'Tomado para revisar',
    'admin.approve': 'Aprobar',
    'admin.approveConfirm': '¿Aprobar este pedido?',
    'admin.approved': 'Aprobado',
    'admin.reject': 'Rechazar',
    'admin.rejectReason': 'Motivo del rechazo (mínimo 10 caracteres):',
    'admin.rejected': 'Pedido devuelto al empleado',
    'admin.markAsSent': 'Marcar como enviado a Metro',
    'admin.metroRefPrompt': 'Número de referencia de Metro (opcional):',
    'admin.markedSent': 'Marcado como enviado',
    'admin.takeFirst': 'Tomá el pedido para revisión primero',
    'admin.byUser': 'Por {email}',

    // Catalog
    'catalog.title': 'Catálogo de Productos',
    'catalog.import': '📄 Importar desde factura PDF',
    'catalog.newProduct': '+ Nuevo producto',
    'catalog.empty': 'No hay productos en el catálogo. Importá una factura o creá uno manualmente.',
    'catalog.stats': '{total} productos totales · {active} activos · {inactive} inactivos · {cats} categorías',
    'catalog.col.sku': 'SKU',
    'catalog.col.product': 'Producto',
    'catalog.col.unit': 'Unidad',
    'catalog.col.price': 'Precio €',
    'catalog.col.status': 'Estado',
    'catalog.col.category': 'Categoría',
    'catalog.statusActive': '✓ Activo',
    'catalog.statusInactive': '✗ Inactivo',
    'catalog.deactivate': 'Desactivar',
    'catalog.deactivateConfirm': '¿Desactivar el producto "{name}"?',
    'catalog.deactivated': 'Desactivado',

    // Product form
    'product.formTitleNew': 'Nuevo producto',
    'product.formTitleEdit': 'Editar producto',
    'product.sku': 'SKU (código)',
    'product.name': 'Nombre',
    'product.unit': 'Unidad',
    'product.priceEur': 'Precio en € (ej: 2,67)',
    'product.category': 'Categoría',
    'product.invalidPrice': 'Precio inválido',
    'product.created': 'Producto creado',
    'product.updated': 'Producto actualizado',

    // Import
    'import.title': 'Importar productos desde factura PDF',
    'import.description': 'Subí una factura de Metro en PDF. Vamos a leer los productos y mostrarte una vista previa antes de importar.',
    'import.fileLabel': 'Archivo PDF (máx 10MB)',
    'import.preview': 'Vista previa',
    'import.processing': 'Procesando...',
    'import.reading': 'Leyendo factura...',
    'import.confirm': 'Confirmar importación',
    'import.confirmDialog': '¿Aplicar todos los cambios al catálogo?',
    'import.close': 'Cerrar',
    'import.choosePdf': 'Elegí un archivo PDF',
    'import.onlyPdf': 'Solo se aceptan PDFs',
    'import.invoiceInfo': 'Factura: {number} · Fecha: {date} · Total: €{total}',
    'import.summary': '📊 {total} productos detectados: {new} nuevos, {update} a actualizar, {same} sin cambios',
    'import.statusNew': '🆕 Nuevo',
    'import.statusUpdate': '🔄 Actualizar',
    'import.statusUnchanged': '✓ Sin cambios',
    'import.warnings': '⚠️ Advertencias:',
    'import.result': 'Importado: {created} nuevos, {updated} actualizados, {skipped} sin cambios',

    // Languages
    'lang.es': 'Español',
    'lang.de': 'Deutsch',
    'lang.pt': 'Português',
    'lang.it': 'Italiano',

    // Units
    'unit.kg': 'kg',
    'unit.unidad': 'unidad',
    'unit.litro': 'litro',
    'unit.gr': 'gr',
    'unit.paquete': 'paquete',

    // PDF letterhead
    'pdf.tel': 'Tel',
    'pdf.email': 'Email',
    'pdf.web': 'Web',
    'pdf.taxNumber': 'Steuer-Nr',
    'pdf.vatId': 'USt-IdNr',
  },

  de: {
    'login.title': 'Wöchentliche Bestellungen',
    'login.email': 'E-Mail',
    'login.password': 'Passwort',
    'login.submit': 'Anmelden',
    'login.loading': 'Wird angemeldet...',
    'login.invalidCredentials': 'Ungültige Anmeldedaten',
    'login.helpText': 'Mitarbeiter: empleado@metro.com / Empleado123!  •  Admin: admin@metro.com / Admin123!',
    'login.fillFields': 'Bitte E-Mail und Passwort ausfüllen',
    'login.welcome': 'Willkommen',

    // User account
    'account.menu': 'Mein Konto',
    'account.changePassword': 'Passwort ändern',
    'account.currentPassword': 'Aktuelles Passwort',
    'account.newPassword': 'Neues Passwort',
    'account.confirmPassword': 'Neues Passwort bestätigen',
    'account.passwordsDontMatch': 'Die Passwörter stimmen nicht überein',
    'account.passwordMin': 'Das Passwort muss mindestens 8 Zeichen haben',
    'account.passwordChanged': 'Passwort erfolgreich geändert',

    // Users management (admin)
    'users.title': 'Benutzer',
    'users.newUser': '+ Neuer Benutzer',
    'users.email': 'E-Mail',
    'users.role': 'Rolle',
    'users.password': 'Passwort',
    'users.status': 'Status',
    'users.lastLogin': 'Letzter Zugriff',
    'users.actions': 'Aktionen',
    'users.roleEmployee': 'Mitarbeiter',
    'users.roleAdmin': 'Administrator',
    'users.statusActive': '✓ Aktiv',
    'users.statusInactive': '✗ Inaktiv',
    'users.never': 'Niemals',
    'users.activate': 'Aktivieren',
    'users.deactivate': 'Deaktivieren',
    'users.resetPassword': 'Passwort zurücksetzen',
    'users.formTitleNew': 'Neuer Benutzer',
    'users.formTitleEdit': 'Benutzer bearbeiten',
    'users.created': 'Benutzer erstellt',
    'users.updated': 'Benutzer aktualisiert',
    'users.passwordReset': 'Passwort zurückgesetzt',
    'users.activated': 'Benutzer aktiviert',
    'users.deactivated': 'Benutzer deaktiviert',
    'users.deactivateConfirm': 'Benutzer "{email}" deaktivieren? Sitzungen werden sofort beendet.',
    'users.activateConfirm': 'Benutzer "{email}" aktivieren?',
    'users.resetPasswordPrompt': 'Neues Passwort für "{email}" (mindestens 8 Zeichen):',

    'header.logout': 'Abmelden',
    'header.catalog': 'Katalog',
    'header.adminTitle': 'Wöchentliche Bestellungen (Admin)',

    'common.loading': 'Wird geladen...',
    'common.cancel': 'Abbrechen',
    'common.confirm': 'Bestätigen',
    'common.accept': 'OK',
    'common.save': 'Speichern',
    'common.delete': 'Löschen',
    'common.edit': 'Bearbeiten',
    'common.back': '← Zurück',
    'common.error': 'Fehler',
    'common.networkError': 'Netzwerkfehler',
    'common.unknownError': 'Unbekannter Fehler',
    'common.requiredField': 'Dieses Feld ist erforderlich',
    'common.minChars': 'Mindestens {n} Zeichen',
    'common.sessionExpired': 'Sitzung abgelaufen, bitte erneut anmelden',

    'status.DRAFT': 'Entwurf',
    'status.SUBMITTED': 'Zur Überprüfung gesendet',
    'status.UNDER_REVIEW': 'In Überprüfung',
    'status.READY_TO_SEND': 'Bereit zum Senden',
    'status.SENT': 'An Metro gesendet',
    'status.CANCELLED': 'Storniert',

    'orders.myOrders': 'Meine Bestellungen',
    'orders.newOrder': '+ Neue Bestellung',
    'orders.empty': 'Noch keine Bestellungen. Auf "+ Neue Bestellung" tippen, um zu starten.',
    'orders.orderCreated': 'Bestellung erstellt',
    'orders.weekOf': 'Woche {week} von {year}',
    'orders.itemCount': '{n} Produkte',

    'orderEditor.title': 'Bestellung',
    'orderEditor.addProduct': 'Produkt hinzufügen',
    'orderEditor.product': 'Produkt',
    'orderEditor.chooseProduct': '-- Produkt auswählen --',
    'orderEditor.quantity': 'Menge',
    'orderEditor.unit': 'Einheit',
    'orderEditor.observations': 'Anmerkungen',
    'orderEditor.observationsOptional': 'Anmerkungen (optional)',
    'orderEditor.addToOrder': 'Zur Bestellung hinzufügen',
    'orderEditor.added': 'Hinzugefügt',
    'orderEditor.remove': 'Entfernen',
    'orderEditor.removeConfirm': 'Dieses Produkt aus der Bestellung entfernen?',
    'orderEditor.removed': 'Entfernt',
    'orderEditor.products': 'Produkte ({n})',
    'orderEditor.empty': 'Noch keine Produkte hinzugefügt.',
    'orderEditor.submit': 'Zur Überprüfung senden',
    'orderEditor.submitConfirm': 'Diese Bestellung an den Administrator senden?',
    'orderEditor.submitted': 'Bestellung zur Überprüfung gesendet',
    'orderEditor.print': 'Drucken / PDF',
    'orderEditor.invalidProduct': 'Produkt und gültige Menge auswählen',
    'orderEditor.sku': 'Art.-Nr.',
    'orderEditor.subtotal': 'Zwischensumme',
    'orderEditor.totalEstimated': 'Geschätzte Summe',
    'orderEditor.totalNote': 'Richtwert basierend auf Preisen der letzten Rechnung',

    'admin.tabs.pending': 'Ausstehend',
    'admin.tabs.review': 'In Überprüfung',
    'admin.tabs.ready': 'Sendebereit',
    'admin.tabs.sent': 'Gesendet',
    'admin.tabs.all': 'Alle',
    'admin.empty': 'Keine Bestellungen in diesem Status.',
    'admin.takeForReview': 'Zur Überprüfung übernehmen',
    'admin.taken': 'Zur Überprüfung übernommen',
    'admin.approve': 'Genehmigen',
    'admin.approveConfirm': 'Diese Bestellung genehmigen?',
    'admin.approved': 'Genehmigt',
    'admin.reject': 'Ablehnen',
    'admin.rejectReason': 'Grund für die Ablehnung (mindestens 10 Zeichen):',
    'admin.rejected': 'Bestellung an Mitarbeiter zurückgegeben',
    'admin.markAsSent': 'Als an Metro gesendet markieren',
    'admin.metroRefPrompt': 'Metro-Referenznummer (optional):',
    'admin.markedSent': 'Als gesendet markiert',
    'admin.takeFirst': 'Bestellung zuerst zur Überprüfung übernehmen',
    'admin.byUser': 'Von {email}',

    'catalog.title': 'Produktkatalog',
    'catalog.import': '📄 Aus PDF-Rechnung importieren',
    'catalog.newProduct': '+ Neues Produkt',
    'catalog.empty': 'Keine Produkte im Katalog. Rechnung importieren oder manuell erstellen.',
    'catalog.stats': '{total} Produkte · {active} aktiv · {inactive} inaktiv · {cats} Kategorien',
    'catalog.col.sku': 'SKU',
    'catalog.col.product': 'Produkt',
    'catalog.col.unit': 'Einheit',
    'catalog.col.price': 'Preis €',
    'catalog.col.status': 'Status',
    'catalog.col.category': 'Kategorie',
    'catalog.statusActive': '✓ Aktiv',
    'catalog.statusInactive': '✗ Inaktiv',
    'catalog.deactivate': 'Deaktivieren',
    'catalog.deactivateConfirm': 'Produkt "{name}" deaktivieren?',
    'catalog.deactivated': 'Deaktiviert',

    'product.formTitleNew': 'Neues Produkt',
    'product.formTitleEdit': 'Produkt bearbeiten',
    'product.sku': 'SKU (Code)',
    'product.name': 'Name',
    'product.unit': 'Einheit',
    'product.priceEur': 'Preis in € (z.B.: 2,67)',
    'product.category': 'Kategorie',
    'product.invalidPrice': 'Ungültiger Preis',
    'product.created': 'Produkt erstellt',
    'product.updated': 'Produkt aktualisiert',

    'import.title': 'Produkte aus PDF-Rechnung importieren',
    'import.description': 'Lade eine Metro-Rechnung als PDF hoch. Die Produkte werden gelesen und vor dem Import als Vorschau angezeigt.',
    'import.fileLabel': 'PDF-Datei (max. 10MB)',
    'import.preview': 'Vorschau',
    'import.processing': 'Wird verarbeitet...',
    'import.reading': 'Rechnung wird gelesen...',
    'import.confirm': 'Import bestätigen',
    'import.confirmDialog': 'Alle Änderungen am Katalog anwenden?',
    'import.close': 'Schließen',
    'import.choosePdf': 'Eine PDF-Datei auswählen',
    'import.onlyPdf': 'Nur PDFs werden akzeptiert',
    'import.invoiceInfo': 'Rechnung: {number} · Datum: {date} · Gesamt: €{total}',
    'import.summary': '📊 {total} Produkte erkannt: {new} neu, {update} zu aktualisieren, {same} unverändert',
    'import.statusNew': '🆕 Neu',
    'import.statusUpdate': '🔄 Aktualisieren',
    'import.statusUnchanged': '✓ Unverändert',
    'import.warnings': '⚠️ Warnungen:',
    'import.result': 'Importiert: {created} neu, {updated} aktualisiert, {skipped} unverändert',

    'lang.es': 'Español',
    'lang.de': 'Deutsch',
    'lang.pt': 'Português',
    'lang.it': 'Italiano',

    // Units
    'unit.kg': 'kg',
    'unit.unidad': 'Stück',
    'unit.litro': 'Liter',
    'unit.gr': 'g',
    'unit.paquete': 'Pkg',

    // PDF letterhead
    'pdf.tel': 'Tel',
    'pdf.email': 'E-Mail',
    'pdf.web': 'Web',
    'pdf.taxNumber': 'Steuer-Nr',
    'pdf.vatId': 'USt-IdNr',
  },

  pt: {
    'login.title': 'Compras Semanais',
    'login.email': 'E-mail',
    'login.password': 'Senha',
    'login.submit': 'Entrar',
    'login.loading': 'Entrando...',
    'login.invalidCredentials': 'Credenciais inválidas',
    'login.helpText': 'Funcionário: empleado@metro.com / Empleado123!  •  Admin: admin@metro.com / Admin123!',
    'login.fillFields': 'Preencha e-mail e senha',
    'login.welcome': 'Bem-vindo',

    // User account
    'account.menu': 'Minha conta',
    'account.changePassword': 'Alterar senha',
    'account.currentPassword': 'Senha atual',
    'account.newPassword': 'Nova senha',
    'account.confirmPassword': 'Confirmar nova senha',
    'account.passwordsDontMatch': 'As senhas não coincidem',
    'account.passwordMin': 'A senha deve ter no mínimo 8 caracteres',
    'account.passwordChanged': 'Senha alterada com sucesso',

    // Users management (admin)
    'users.title': 'Usuários',
    'users.newUser': '+ Novo usuário',
    'users.email': 'E-mail',
    'users.role': 'Função',
    'users.password': 'Senha',
    'users.status': 'Estado',
    'users.lastLogin': 'Último acesso',
    'users.actions': 'Ações',
    'users.roleEmployee': 'Funcionário',
    'users.roleAdmin': 'Administrador',
    'users.statusActive': '✓ Ativo',
    'users.statusInactive': '✗ Inativo',
    'users.never': 'Nunca',
    'users.activate': 'Ativar',
    'users.deactivate': 'Desativar',
    'users.resetPassword': 'Redefinir senha',
    'users.formTitleNew': 'Novo usuário',
    'users.formTitleEdit': 'Editar usuário',
    'users.created': 'Usuário criado',
    'users.updated': 'Usuário atualizado',
    'users.passwordReset': 'Senha redefinida',
    'users.activated': 'Usuário ativado',
    'users.deactivated': 'Usuário desativado',
    'users.deactivateConfirm': 'Desativar o usuário "{email}"? Suas sessões serão encerradas.',
    'users.activateConfirm': 'Ativar o usuário "{email}"?',
    'users.resetPasswordPrompt': 'Nova senha para "{email}" (mínimo 8 caracteres):',

    'header.logout': 'Sair',
    'header.catalog': 'Catálogo',
    'header.adminTitle': 'Compras Semanais (Admin)',

    'common.loading': 'Carregando...',
    'common.cancel': 'Cancelar',
    'common.confirm': 'Confirmar',
    'common.accept': 'OK',
    'common.save': 'Salvar',
    'common.delete': 'Excluir',
    'common.edit': 'Editar',
    'common.back': '← Voltar',
    'common.error': 'Erro',
    'common.networkError': 'Erro de rede',
    'common.unknownError': 'Erro desconhecido',
    'common.requiredField': 'Este campo é obrigatório',
    'common.minChars': 'Mínimo de {n} caracteres',
    'common.sessionExpired': 'Sessão expirada, faça login novamente',

    'status.DRAFT': 'Rascunho',
    'status.SUBMITTED': 'Enviado para revisão',
    'status.UNDER_REVIEW': 'Em revisão',
    'status.READY_TO_SEND': 'Pronto para envio',
    'status.SENT': 'Enviado ao Metro',
    'status.CANCELLED': 'Cancelado',

    'orders.myOrders': 'Meus Pedidos',
    'orders.newOrder': '+ Novo pedido',
    'orders.empty': 'Você ainda não tem pedidos. Toque em "+ Novo pedido" para começar.',
    'orders.orderCreated': 'Pedido criado',
    'orders.weekOf': 'Semana {week} de {year}',
    'orders.itemCount': '{n} produtos',

    'orderEditor.title': 'Pedido',
    'orderEditor.addProduct': 'Adicionar produto',
    'orderEditor.product': 'Produto',
    'orderEditor.chooseProduct': '-- Escolha um produto --',
    'orderEditor.quantity': 'Quantidade',
    'orderEditor.unit': 'Unidade',
    'orderEditor.observations': 'Observações',
    'orderEditor.observationsOptional': 'Observações (opcional)',
    'orderEditor.addToOrder': 'Adicionar ao pedido',
    'orderEditor.added': 'Adicionado',
    'orderEditor.remove': 'Remover',
    'orderEditor.removeConfirm': 'Remover este produto do pedido?',
    'orderEditor.removed': 'Removido',
    'orderEditor.products': 'Produtos ({n})',
    'orderEditor.empty': 'Você ainda não adicionou produtos.',
    'orderEditor.submit': 'Enviar para revisão',
    'orderEditor.submitConfirm': 'Enviar este pedido ao administrador?',
    'orderEditor.submitted': 'Pedido enviado para revisão',
    'orderEditor.print': 'Imprimir / PDF',
    'orderEditor.invalidProduct': 'Escolha um produto e quantidade válida',
    'orderEditor.sku': 'SKU',
    'orderEditor.subtotal': 'Subtotal',
    'orderEditor.totalEstimated': 'Total estimado',
    'orderEditor.totalNote': 'Valor orientativo com base nos preços da última fatura',

    'admin.tabs.pending': 'Pendentes',
    'admin.tabs.review': 'Em revisão',
    'admin.tabs.ready': 'Prontos para envio',
    'admin.tabs.sent': 'Enviados',
    'admin.tabs.all': 'Todos',
    'admin.empty': 'Sem pedidos neste estado.',
    'admin.takeForReview': 'Pegar para revisar',
    'admin.taken': 'Pego para revisar',
    'admin.approve': 'Aprovar',
    'admin.approveConfirm': 'Aprovar este pedido?',
    'admin.approved': 'Aprovado',
    'admin.reject': 'Rejeitar',
    'admin.rejectReason': 'Motivo da rejeição (mínimo 10 caracteres):',
    'admin.rejected': 'Pedido devolvido ao funcionário',
    'admin.markAsSent': 'Marcar como enviado ao Metro',
    'admin.metroRefPrompt': 'Número de referência do Metro (opcional):',
    'admin.markedSent': 'Marcado como enviado',
    'admin.takeFirst': 'Pegue o pedido para revisão primeiro',
    'admin.byUser': 'Por {email}',

    'catalog.title': 'Catálogo de Produtos',
    'catalog.import': '📄 Importar de fatura PDF',
    'catalog.newProduct': '+ Novo produto',
    'catalog.empty': 'Sem produtos no catálogo. Importe uma fatura ou crie manualmente.',
    'catalog.stats': '{total} produtos · {active} ativos · {inactive} inativos · {cats} categorias',
    'catalog.col.sku': 'SKU',
    'catalog.col.product': 'Produto',
    'catalog.col.unit': 'Unidade',
    'catalog.col.price': 'Preço €',
    'catalog.col.status': 'Estado',
    'catalog.col.category': 'Categoria',
    'catalog.statusActive': '✓ Ativo',
    'catalog.statusInactive': '✗ Inativo',
    'catalog.deactivate': 'Desativar',
    'catalog.deactivateConfirm': 'Desativar o produto "{name}"?',
    'catalog.deactivated': 'Desativado',

    'product.formTitleNew': 'Novo produto',
    'product.formTitleEdit': 'Editar produto',
    'product.sku': 'SKU (código)',
    'product.name': 'Nome',
    'product.unit': 'Unidade',
    'product.priceEur': 'Preço em € (ex: 2,67)',
    'product.category': 'Categoria',
    'product.invalidPrice': 'Preço inválido',
    'product.created': 'Produto criado',
    'product.updated': 'Produto atualizado',

    'import.title': 'Importar produtos de fatura PDF',
    'import.description': 'Envie uma fatura do Metro em PDF. Vamos ler os produtos e mostrar uma prévia antes de importar.',
    'import.fileLabel': 'Arquivo PDF (máx 10MB)',
    'import.preview': 'Prévia',
    'import.processing': 'Processando...',
    'import.reading': 'Lendo fatura...',
    'import.confirm': 'Confirmar importação',
    'import.confirmDialog': 'Aplicar todas as alterações ao catálogo?',
    'import.close': 'Fechar',
    'import.choosePdf': 'Escolha um arquivo PDF',
    'import.onlyPdf': 'Só são aceitos PDFs',
    'import.invoiceInfo': 'Fatura: {number} · Data: {date} · Total: €{total}',
    'import.summary': '📊 {total} produtos detectados: {new} novos, {update} a atualizar, {same} sem alteração',
    'import.statusNew': '🆕 Novo',
    'import.statusUpdate': '🔄 Atualizar',
    'import.statusUnchanged': '✓ Sem alteração',
    'import.warnings': '⚠️ Avisos:',
    'import.result': 'Importado: {created} novos, {updated} atualizados, {skipped} sem alteração',

    'lang.es': 'Español',
    'lang.de': 'Deutsch',
    'lang.pt': 'Português',
    'lang.it': 'Italiano',

    // Units
    'unit.kg': 'kg',
    'unit.unidad': 'unidade',
    'unit.litro': 'litro',
    'unit.gr': 'g',
    'unit.paquete': 'pct',

    // PDF letterhead
    'pdf.tel': 'Tel',
    'pdf.email': 'E-mail',
    'pdf.web': 'Web',
    'pdf.taxNumber': 'Steuer-Nr',
    'pdf.vatId': 'USt-IdNr',
  },

  it: {
    'login.title': 'Acquisti Settimanali',
    'login.email': 'Email',
    'login.password': 'Password',
    'login.submit': 'Accedi',
    'login.loading': 'Accesso in corso...',
    'login.invalidCredentials': 'Credenziali non valide',
    'login.helpText': 'Dipendente: empleado@metro.com / Empleado123!  •  Admin: admin@metro.com / Admin123!',
    'login.fillFields': 'Inserisci email e password',
    'login.welcome': 'Benvenuto',

    // User account
    'account.menu': 'Mio account',
    'account.changePassword': 'Cambia password',
    'account.currentPassword': 'Password attuale',
    'account.newPassword': 'Nuova password',
    'account.confirmPassword': 'Conferma nuova password',
    'account.passwordsDontMatch': 'Le password non corrispondono',
    'account.passwordMin': 'La password deve avere almeno 8 caratteri',
    'account.passwordChanged': 'Password modificata correttamente',

    // Users management (admin)
    'users.title': 'Utenti',
    'users.newUser': '+ Nuovo utente',
    'users.email': 'Email',
    'users.role': 'Ruolo',
    'users.password': 'Password',
    'users.status': 'Stato',
    'users.lastLogin': 'Ultimo accesso',
    'users.actions': 'Azioni',
    'users.roleEmployee': 'Dipendente',
    'users.roleAdmin': 'Amministratore',
    'users.statusActive': '✓ Attivo',
    'users.statusInactive': '✗ Inattivo',
    'users.never': 'Mai',
    'users.activate': 'Attiva',
    'users.deactivate': 'Disattiva',
    'users.resetPassword': 'Reimposta password',
    'users.formTitleNew': 'Nuovo utente',
    'users.formTitleEdit': 'Modifica utente',
    'users.created': 'Utente creato',
    'users.updated': 'Utente aggiornato',
    'users.passwordReset': 'Password reimpostata',
    'users.activated': 'Utente attivato',
    'users.deactivated': 'Utente disattivato',
    'users.deactivateConfirm': 'Disattivare l\'utente "{email}"? Le sessioni saranno terminate.',
    'users.activateConfirm': 'Attivare l\'utente "{email}"?',
    'users.resetPasswordPrompt': 'Nuova password per "{email}" (minimo 8 caratteri):',

    'header.logout': 'Esci',
    'header.catalog': 'Catalogo',
    'header.adminTitle': 'Acquisti Settimanali (Admin)',

    'common.loading': 'Caricamento...',
    'common.cancel': 'Annulla',
    'common.confirm': 'Conferma',
    'common.accept': 'OK',
    'common.save': 'Salva',
    'common.delete': 'Elimina',
    'common.edit': 'Modifica',
    'common.back': '← Indietro',
    'common.error': 'Errore',
    'common.networkError': 'Errore di rete',
    'common.unknownError': 'Errore sconosciuto',
    'common.requiredField': 'Questo campo è obbligatorio',
    'common.minChars': 'Minimo {n} caratteri',
    'common.sessionExpired': 'Sessione scaduta, accedi di nuovo',

    'status.DRAFT': 'Bozza',
    'status.SUBMITTED': 'Inviato per revisione',
    'status.UNDER_REVIEW': 'In revisione',
    'status.READY_TO_SEND': 'Pronto per invio',
    'status.SENT': 'Inviato a Metro',
    'status.CANCELLED': 'Annullato',

    'orders.myOrders': 'I Miei Ordini',
    'orders.newOrder': '+ Nuovo ordine',
    'orders.empty': 'Nessun ordine ancora. Tocca "+ Nuovo ordine" per iniziare.',
    'orders.orderCreated': 'Ordine creato',
    'orders.weekOf': 'Settimana {week} del {year}',
    'orders.itemCount': '{n} prodotti',

    'orderEditor.title': 'Ordine',
    'orderEditor.addProduct': 'Aggiungi prodotto',
    'orderEditor.product': 'Prodotto',
    'orderEditor.chooseProduct': '-- Scegli un prodotto --',
    'orderEditor.quantity': 'Quantità',
    'orderEditor.unit': 'Unità',
    'orderEditor.observations': 'Osservazioni',
    'orderEditor.observationsOptional': 'Osservazioni (facoltative)',
    'orderEditor.addToOrder': 'Aggiungi all\'ordine',
    'orderEditor.added': 'Aggiunto',
    'orderEditor.remove': 'Rimuovi',
    'orderEditor.removeConfirm': 'Rimuovere questo prodotto dall\'ordine?',
    'orderEditor.removed': 'Rimosso',
    'orderEditor.products': 'Prodotti ({n})',
    'orderEditor.empty': 'Nessun prodotto aggiunto.',
    'orderEditor.submit': 'Invia per revisione',
    'orderEditor.submitConfirm': 'Inviare questo ordine all\'amministratore?',
    'orderEditor.submitted': 'Ordine inviato per revisione',
    'orderEditor.print': 'Stampa / PDF',
    'orderEditor.invalidProduct': 'Scegli un prodotto e una quantità valida',
    'orderEditor.sku': 'Codice',
    'orderEditor.subtotal': 'Subtotale',
    'orderEditor.totalEstimated': 'Totale stimato',
    'orderEditor.totalNote': 'Importo indicativo basato sui prezzi dell\'ultima fattura',

    'admin.tabs.pending': 'In attesa',
    'admin.tabs.review': 'In revisione',
    'admin.tabs.ready': 'Pronti per invio',
    'admin.tabs.sent': 'Inviati',
    'admin.tabs.all': 'Tutti',
    'admin.empty': 'Nessun ordine in questo stato.',
    'admin.takeForReview': 'Prendi in revisione',
    'admin.taken': 'Preso in revisione',
    'admin.approve': 'Approva',
    'admin.approveConfirm': 'Approvare questo ordine?',
    'admin.approved': 'Approvato',
    'admin.reject': 'Rifiuta',
    'admin.rejectReason': 'Motivo del rifiuto (minimo 10 caratteri):',
    'admin.rejected': 'Ordine restituito al dipendente',
    'admin.markAsSent': 'Segna come inviato a Metro',
    'admin.metroRefPrompt': 'Numero di riferimento Metro (facoltativo):',
    'admin.markedSent': 'Segnato come inviato',
    'admin.takeFirst': 'Prendi prima l\'ordine in revisione',
    'admin.byUser': 'Da {email}',

    'catalog.title': 'Catalogo Prodotti',
    'catalog.import': '📄 Importa da fattura PDF',
    'catalog.newProduct': '+ Nuovo prodotto',
    'catalog.empty': 'Nessun prodotto nel catalogo. Importa una fattura o creane uno manualmente.',
    'catalog.stats': '{total} prodotti · {active} attivi · {inactive} inattivi · {cats} categorie',
    'catalog.col.sku': 'SKU',
    'catalog.col.product': 'Prodotto',
    'catalog.col.unit': 'Unità',
    'catalog.col.price': 'Prezzo €',
    'catalog.col.status': 'Stato',
    'catalog.col.category': 'Categoria',
    'catalog.statusActive': '✓ Attivo',
    'catalog.statusInactive': '✗ Inattivo',
    'catalog.deactivate': 'Disattiva',
    'catalog.deactivateConfirm': 'Disattivare il prodotto "{name}"?',
    'catalog.deactivated': 'Disattivato',

    'product.formTitleNew': 'Nuovo prodotto',
    'product.formTitleEdit': 'Modifica prodotto',
    'product.sku': 'SKU (codice)',
    'product.name': 'Nome',
    'product.unit': 'Unità',
    'product.priceEur': 'Prezzo in € (es: 2,67)',
    'product.category': 'Categoria',
    'product.invalidPrice': 'Prezzo non valido',
    'product.created': 'Prodotto creato',
    'product.updated': 'Prodotto aggiornato',

    'import.title': 'Importa prodotti da fattura PDF',
    'import.description': 'Carica una fattura Metro in PDF. Leggeremo i prodotti e mostreremo un\'anteprima prima dell\'importazione.',
    'import.fileLabel': 'File PDF (max 10MB)',
    'import.preview': 'Anteprima',
    'import.processing': 'Elaborazione...',
    'import.reading': 'Lettura fattura...',
    'import.confirm': 'Conferma importazione',
    'import.confirmDialog': 'Applicare tutte le modifiche al catalogo?',
    'import.close': 'Chiudi',
    'import.choosePdf': 'Scegli un file PDF',
    'import.onlyPdf': 'Solo PDF accettati',
    'import.invoiceInfo': 'Fattura: {number} · Data: {date} · Totale: €{total}',
    'import.summary': '📊 {total} prodotti rilevati: {new} nuovi, {update} da aggiornare, {same} invariati',
    'import.statusNew': '🆕 Nuovo',
    'import.statusUpdate': '🔄 Aggiornare',
    'import.statusUnchanged': '✓ Invariato',
    'import.warnings': '⚠️ Avvertenze:',
    'import.result': 'Importati: {created} nuovi, {updated} aggiornati, {skipped} invariati',

    'lang.es': 'Español',
    'lang.de': 'Deutsch',
    'lang.pt': 'Português',
    'lang.it': 'Italiano',

    // Units
    'unit.kg': 'kg',
    'unit.unidad': 'pz',
    'unit.litro': 'litro',
    'unit.gr': 'g',
    'unit.paquete': 'conf',

    // PDF letterhead
    'pdf.tel': 'Tel',
    'pdf.email': 'Email',
    'pdf.web': 'Web',
    'pdf.taxNumber': 'Steuer-Nr',
    'pdf.vatId': 'USt-IdNr',
  },
} as const;

export type Locale = keyof typeof dictionaries;
export type TranslationKey = keyof typeof dictionaries.es;
